'use client'

import { useState, useEffect } from 'react'
import type { User } from '@/lib/types'

interface UserHeaderProps {
  user?: User
  onClick?: VoidFunction
}

export const UserHeader = ({ onClick, user }: UserHeaderProps) => {
  const [imageError, setImageError] = useState(false)

  // Reset error state when user or avatar changes
  useEffect(() => {
    setImageError(false)
  }, [user?.avatar])

  if (!user) {
    return null
  }

  const displayInitials = user.email.slice(0, 2).toUpperCase()

  return (
    <button
      type="button"
      className="h-8 w-8 md:size-10 rounded-full bg-brand flex items-center justify-center text-white text-sm font-medium uppercase overflow-hidden relative"
      onClick={() => onClick?.()}
    >
      {user.avatar && !imageError ? (
        <img
          src={user.avatar}
          alt={user.name || user.email}
          className="w-full h-full object-cover"
          onError={() => {
            setImageError(true)
          }}
        />
      ) : (
        displayInitials
      )}
    </button>
  )
}
